/* eslint-disable max-len */
import { Toggle } from '@nazka/nazka.mapframe.components';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './background-layer-selector.styl';
import { addSourcesAndLayersFromConfigToMap } from '@library/MaplibreMap/maplibre-map.factory'
import Select from 'react-select';
import Municipality from '../Municipality/Municipality';
import { setCurrentBaseMapStyle } from '../../../library/MaplibreMap/maplibre-map.redux.actions';
import { options } from './background-layer-selector.constants';
import { addSourcesAndLayers } from '../../../library/MaplibreMap/controls/Controls/CustomControls/MeasurementControl/measurement-control.layers';

function BackgroundLayerSelector() {
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false);
  const [showOrthophoto, setShowOrthophoto] = useState(false);
  const [showMunicipality, setShowMunicipality] = useState(false);
  const map = useSelector(state => state.maplibreMap.map);
  const [choosedCountry, setChoosedCountry] = useState(options[28])

  const toggleIsOpen = () => {
    setIsOpen(prevState => !prevState);
  };

  const toggleShowOrthophoto = (e) => {
    setShowOrthophoto(e.target.checked);
    const layerss = [...map.getStyle().layers]
    layerss.forEach(layer => map.removeLayer(layer.id))

    map.setStyle(
      `https://api.maptiler.com/maps/${e.target.checked ? '0196d7b1-c830-7a2d-bc8f-c45662921eb8' : '5c22ba3e-a7a2-4fdd-9cc0-2e9304b1812c'}/style.json?key=${import.meta.env.VITE_MAPTILER_TOKEN}`,
    )
    map.once('idle', () => {
      addSourcesAndLayersFromConfigToMap(map);
      addSourcesAndLayers(map, {
        position: 'topright',
        collapsed: true,
        shapes: ['circle', 'rectangle', 'polygon'],
        unitSystem: 'metric',
        actionsToFinish: ['dblclick', 'esc-key', 'click-first', 'click-last'],
        displayDialogPopup: true,
        displayLength: true,
        displayArea: true,
        displayCircleRadius: true,
        lineColor: '#0367A5',
        fillColor: 'rgba(3, 103, 165, 0.046)',
        helperDotColor: '#555',
      })
      dispatch(setCurrentBaseMapStyle(e.target.checked ? 'satellite' : 'street'))
    });
  };

  const toggleShowMunicipality = (e) => {
    setShowMunicipality(e.target.checked);
  };

  return (
    <div className="backgound-layer-selector__container">
      <div className={`z-depth-1 backgound-layer-selector__options__wrapper
       ${isOpen ? 'backgound-layer-selector__options__wrapper--expanded' : 'backgound-layer-selector__options__wrapper--closed'}`}
      >
        <div>
          <div>
            <Toggle
              label="Satellite"
              name="Satellite"
              checked={showOrthophoto}
              onInputChange={toggleShowOrthophoto}
              activeColor="#0367A5"
              css={{ 
                fontSize: '14px',
                input: { fontSize: '12px' },
                color: '#0367A5',
              }}
            />
          </div>
        </div>
        <div>
          <div>
            <Toggle
              label="Local boundaries"
              name="Municipalities"
              checked={showMunicipality}
              onInputChange={toggleShowMunicipality}
              activeColor="#0367A5"
              css={{ 
                fontSize: '14px',
                input: { fontSize: '12px' },
                color: '#0367A5',
              }}
            />
          </div>
          {showMunicipality && (
            <Select
              options={options}
              defaultValue={options[28]}
              onChange={selectedOption => setChoosedCountry(selectedOption)}
              value={choosedCountry}
            />
          )}
          
        </div>
      </div>
      <div>
        <button type="button" onClick={toggleIsOpen} className="background-layer-selector__button" />
      </div>

      {/* {map && showOrthophoto && (
        <OrthophotoLayer map={map} />
      )} */}
      {map && showMunicipality && (
      <Municipality map={map} choosedCountry={choosedCountry} />
      )}
    </div>
  )
}

export default BackgroundLayerSelector